import TaskCard from "./TaskCard"

function TaskColumn({ title, tasks, onMoveTask, onEditTask, showEditButton }) {
  return (
    <div className="task-column">
      <div className="column-header">
        <h3>{title}</h3>
      </div>
    <hr className="custom-hr" />
      <div className="tasks-list">
        {tasks.length === 0 ? (
          <div className="empty-state">No {title.toLowerCase()} tasks</div>
        ) : (
          tasks.map((task) => (
            <TaskCard
              key={task.id}
              task={task}
              onMove={onMoveTask}
              onEdit={onEditTask}
              showEditButton={showEditButton}
            />
          ))
        )}
      </div>
    </div>
  )
}

export default TaskColumn
